import React, { useRef, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useEffect } from 'react'
import PageTitle from '../../common/components/PageTitle';

import { getParameterValues, downloadReport, responseAsImage } from './service/ReportService';
import DateFilter from './components/DateFilter';
import { useAuthentication } from 'common/contexts/Authentication';
import TagFilter from './components/TagFilter';
import ReportImage from './components/ReportImage';
import './styles/styles.css';
import { Card } from 'react-bootstrap';
import ReportCard from './components/ReportCard';

const availableReports = [
  { key: 'openedVouchers', title: 'Opened vouchers' },
  { key: 'usedVouchers', title: 'Used vouchers' }
];

const FilterWrapper = ({ title = '', iconClassName = '', children, wrapperStyle = {}, titleWrapperStyle = {} }) => {

  return <div style={{ display:'inline-flex', justifyContent: 'space-evenly', ...wrapperStyle }}>
    <div style={{ display:'inline-flex', 'justifyContent': 'space-between' }} >
      <i className={iconClassName}></i>
      <span>
        {title}
      </span>
    </div>
    <div >
      {children}
    </div>
  </div>;
};
const Reports = ({ t }) => {

  const authentication = useAuthentication();
  const [availableTags, setAvailableTags] = useState([]);
  const [filters, setFilters] = useState({
  });
  const imageRefs = useRef([]);

  useEffect(() => {
    document.title = t('reports.title')
  }, [t]);

  useEffect(() => {
    getParameterValues(authentication.getMerchantUuid(), 'etuisa', 'tags').then((tags) => {
      setAvailableTags(tags);
    });
  }, [authentication]);

  useEffect(()=>{
    handleApplyFilters();
  }, []);

  const handleApplyFilters = async () => {
    availableReports.forEach(async (report, index) => {
      const response = await downloadReport(authentication.getMerchantUuid(), 'etuisa', {
        chartKey: report.key,
        ...filters,
      });
      responseAsImage(response, imageRefs.current[index]);
    });
  };

  const updateFilter = (filter, value) => {
    setFilters(filters => ({ ...filters, [filter]: value }));
  };

  return (
    <section>
      <PageTitle t={t} />
      <div className="row">
        <div className="col-sm-10">
          <div style={{ display:'inline-flex', 'justifyContent': 'space-between', gap: '5em' }}>
            <FilterWrapper title="From" iconClassName="far fa-calendar" >
              <DateFilter onChange={date => updateFilter('dateFrom', date)} />
            </FilterWrapper>

            <FilterWrapper title="To" iconClassName="far fa-calendar">
              <DateFilter onChange={date => updateFilter('dateTo', date)} />
            </FilterWrapper>

            <FilterWrapper title="Tags" iconClassName="fas fa-tags" wrapperStyle={{ width: '30em', flexWrap: 'wrap' }} titleWrapperStyle={{}}>
              <TagFilter availableTags={availableTags} onChange={(tags) => updateFilter('tags', tags.map(tag => tag.key))} />
            </FilterWrapper>
          </div>
        </div>
        <div className="col-sm-2">
          <button type="submit" className="btn btn-primary" onClick={handleApplyFilters}>Apply filters</button>
        </div>
      </div>
      <div>
        <div className="cards row">
          {availableReports.map((report, index) => <ReportCard title={report.title} className="col-sm-6 col-lg-6">
            <ReportImage reportKey={report.key} imageRef={(ref) => { imageRefs.current[index] = ref; }} />
          </ReportCard>)}
        </div>
      </div>
    </section >
  );
};


export default withTranslation('reports')(Reports);
